import { render } from "./InvoiceRibbon.vue?vue&type=template&id=c39bd5b6"
import script from "./InvoiceRibbon.vue?vue&type=script&lang=js"
export * from "./InvoiceRibbon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__